import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import UserMenu from "../shared/UserMenu";

const Navigation: React.FC = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const { isAuthenticated, isLoading } = useAuth();

    return (
        <>
            {/* Mobile Controls Wrapper - Shows on screens below 991px */}
            <div className="mobile-nav-controls" style={{
                display: 'flex',
                alignItems: 'center',
            }}>
                

                {/* Mobile Auth - Shows beside toggler on mobile ONLY when logged in */}
                {!isLoading && isAuthenticated && (
                    <div className="mobile-auth" style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px'
                    }}>
                        <UserMenu />
                    </div>
                )}

                {/* Button */}
                <button
                    className="navbar-toggler"
                    type="button"
                    onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                    aria-controls="navbar"
                    aria-expanded={isMobileMenuOpen}
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon">
                        <i className={isMobileMenuOpen ? "ti-close" : "ti-menu"}></i>
                    </span>
                </button>
            </div>

            {/* Menu */}
            <div className={`collapse navbar-collapse ${isMobileMenuOpen ? "show" : ""}`} id="navbar">
                <ul className="navbar-nav ms-auto">
                    <li className="nav-item">
                        <a className="nav-link" href="http://ventustravel.co.uk/">
                            Home
                        </a>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link" to="/about-us">
                            About Us
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link" to="/#destinations">
                            Destinations
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link" target="_blank" to="https://www.ventustravel.co.uk/the-magazine">
                            The Magazine
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link" to="/buy-outs">
                            Buy Outs
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link" target="_blank" to="https://www.ventustravel.co.uk/contact-us">
                            Contact Us
                        </Link>
                    </li>
                    
                    {/* Authentication Links */}
                    {!isLoading && (
                        <>
                            {isAuthenticated ? (
                                <li className="nav-item desktop-auth" style={{ display: 'flex', alignItems: 'center', marginLeft: '10px' }}>
                                    <UserMenu />
                                </li>
                            ) : (
                                <>
                                    <li className="nav-item login-btn mobile-nav-auth desktop-auth">
                                        <Link className="nav-link" to="/login">
                                            <i className="ti-user"></i> Login
                                        </Link>
                                    </li>
                                    <li className="nav-item signup-btn mobile-nav-auth desktop-auth">
                                        <Link 
                                            className="nav-link" 
                                            to="/signup"
                                            style={{
                                                background: '#aa8453',
                                                color: '#fff',
                                                padding: '8px 20px',
                                                borderRadius: '4px',
                                                marginLeft: '10px',
                                                border: 'none',
                                                cursor: 'pointer',
                                                textDecoration: 'none',
                                                display: 'inline-block'
                                            }}
                                        >
                                            Sign Up
                                        </Link>
                                    </li>
                                </>
                            )}
                        </>
                    )}
                </ul>
            </div>
        </>
    );
};

export default Navigation;
